import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { useReplaceMessage } from "../../../../hooks/useReplaceMessage";
import { useReplaceEmoji } from "../../hooks/useReemplaceEmoji";
import MessageButtons from "./MessageButtons";
import MessageMedia from "./MessageMedia";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 3000,
  fade: true,
};

const _Carrousel = ({ data = [] }) => {
  const { values } = useFormikContext();
  const replaceMessage = useReplaceMessage(values.fieldsInfo);
  const replaceEmoji = useReplaceEmoji();
  if (!data.length) return <p>No hay elementos en el carrusel</p>;

  return (
    <div className="max-w-[600px] mx-auto overflow-hidden">
      <Slider {...settings}>
        {data.map((item, index) => (
          <div key={index}>
            <MessageMedia media={item.imageUrl} />
            <div className="p-4">
              <div className="font-semibold text-xl text-gray-800 mb-1">
                {replaceEmoji(replaceMessage(item.title)) ||
                  "Título del mensaje"}
              </div>
              <div className="text-gray-600 text-sm mb-3 min-h-[48px] break-words whitespace-pre-wrap">
                {replaceEmoji(replaceMessage(item.description)) ||
                  "Escriba su mensaje"}
              </div>
            </div>
            <MessageButtons
              actions={item.buttonActions}
              quickReplies={item.buttonQuickReplies}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

_Carrousel.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
};

export default _Carrousel;
